import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Drop, PersonSimpleWalk, Moon, ForkKnife } from "@phosphor-icons/react";

const HABITS = [
  { key: "water", label: "Water Intake", icon: Drop },
  { key: "steps", label: "Step Target", icon: PersonSimpleWalk },
  { key: "sleep", label: "7+ Hours Sleep", icon: Moon },
  { key: "macros", label: "Hit Macros", icon: ForkKnife },
];

export default function HabitTracker() {
  const [habit, setHabit] = useState(null);
  const [history, setHistory] = useState([]);

  const load = () => {
    api.get("/portal/habits/today").then(({ data }) => setHabit(data)).catch(() => {});
    api.get("/portal/habits/history").then(({ data }) => setHistory(data)).catch(() => {});
  };

  useEffect(() => {
    load();
  }, []);

  const toggle = async (key) => {
    const updated = { ...habit, [key]: !habit[key] };
    setHabit(updated);
    await api.post("/portal/habits", updated);
    load();
  };

  if (!habit) return null;

  return (
    <div data-testid="habit-tracker">
      <h1 className="font-heading text-3xl text-white tracking-tight mb-6">Daily Habits</h1>
      <div className="grid sm:grid-cols-2 gap-4 mb-10">
        {HABITS.map((h) => {
          const Icon = h.icon;
          const active = habit[h.key];
          return (
            <button
              key={h.key}
              data-testid={`habit-toggle-${h.key}`}
              onClick={() => toggle(h.key)}
              className={`flex items-center gap-4 p-5 rounded-2xl border transition-colors text-left ${
                active ? "border-[#D4AF37] bg-[#D4AF37]/10" : "border-[#27272A] bg-[#141414]"
              }`}
            >
              <Icon size={28} weight={active ? "fill" : "regular"} className={active ? "text-[#D4AF37]" : "text-[#71717A]"} />
              <div>
                <p className="text-white font-semibold">{h.label}</p>
                <p className="text-xs text-[#71717A]">{active ? "Completed today" : "Tap to mark done"}</p>
              </div>
            </button>
          );
        })}
      </div>
      <h2 className="font-heading text-xl text-white tracking-tight mb-4">Last 7 Days</h2>
      <div className="flex gap-2">
        {history
          .slice(0, 7)
          .reverse()
          .map((h) => {
            const score = ["water", "steps", "sleep", "macros"].filter((k) => h[k]).length;
            return (
              <div key={h.date} data-testid={`habit-history-${h.date}`} className="flex-1 text-center">
                <div className="h-16 bg-[#141414] border border-[#27272A] rounded-lg flex items-end overflow-hidden">
                  <div style={{ height: `${(score / 4) * 100}%` }} className="w-full bg-[#D4AF37]" />
                </div>
                <p className="text-xs text-[#71717A] mt-1">{h.date.slice(5)}</p>
              </div>
            );
          })}
      </div>
    </div>
  );
}
